import React from 'react';
import { ChevronRight } from 'lucide-react';
import { cn } from '../../lib/utils';

export function PathStageChips({ stages = [], className }) {
  return (
    <div className={cn('flex min-w-0 flex-wrap items-center gap-1', className)}>
      {stages.map((stage, index) => (
        <React.Fragment key={`${stage}-${index}`}>
          {index > 0 ? (
            <ChevronRight className="h-3.5 w-3.5 shrink-0 text-slate-300" aria-hidden="true" />
          ) : null}
          <span className="rounded-md bg-[#E8EEF8] px-2 py-1 text-[11px] font-semibold text-[var(--brand-primary,#1A428A)]">
            {stage}
          </span>
        </React.Fragment>
      ))}
    </div>
  );
}
